<script>
import compoment from '@/components/draggable/VipDefaultComponents/DVipEditor'
export default {
  name: 'DUsernameEditor',
  extends: compoment
}
</script>
